(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-banner"] && !Shopify.designMode) return;
  try {
    
class HeroSlider extends HTMLElement {
  constructor() {
    super();
    this.track = this.querySelector('[data-track]');
    this.slides = Array.from(this.querySelectorAll('[data-slide]'));
    this.dots = Array.from(this.querySelectorAll('[data-dot]'));
    this.prevBtn = this.querySelector('[data-prev]');
    this.nextBtn = this.querySelector('[data-next]');
    this.toggleBtn = this.querySelector('[data-autoplay-toggle]');
    this.live = this.querySelector('[data-live]');
    this.count = this.slides.length;
    this.index = 0;
    this.timer = null;
    this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.autoplayEnabled = this.hasAttribute('data-autoplay') && !this.reduceMotion;
    // If autoplay is off (or reduced motion), treat it as user-paused so the
    // toggle button — if present — starts in the "Play" state.
    this.userPaused = !this.autoplayEnabled;
    this.speed = (parseFloat(this.getAttribute('data-speed')) || 5) * 1000;
  }

  connectedCallback() {
    // Clickable-slide navigation must run for ANY slide count (a single-slide
    // hero can be clickable too), so wire it up before the multi-slide guard.
    this.setupClickableSlides();

    if (this.count <= 1) return;

    if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.go(this.index - 1, true));
    if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.go(this.index + 1, true));
    this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.go(i, true)));
    if (this.track) this.track.addEventListener('scroll', this.onScroll.bind(this), { passive: true });
    if (this.toggleBtn) this.toggleBtn.addEventListener('click', () => this.toggle());

    // Transient pauses (don't change the user's intended state).
    this.addEventListener('mouseenter', () => this.stopTimer());
    this.addEventListener('mouseleave', () => this.startTimer());
    this.addEventListener('focusin', () => this.stopTimer());
    this.addEventListener('focusout', (e) => { if (!this.contains(e.relatedTarget)) this.startTimer(); });
    document.addEventListener('visibilitychange', () => {
      document.hidden ? this.stopTimer() : this.startTimer();
    });

    this.reflectToggle();
    this.update();
    this.startTimer();
  }

  /* --- Clickable slides ---------------------------------------------------
     Native scroll-snap tracks eat taps on touch: any small finger movement is
     treated as a horizontal pan and the <a>'s click is cancelled, so on mobile
     the whole-slide link often never fires. We therefore detect tap-vs-swipe
     from pointer events and navigate on a genuine tap, while leaving the real
     <a> to handle keyboard, and cmd/ctrl/middle-click open-in-new-tab. */
  setupClickableSlides() {
    if (!this.track) return;

    let startX = 0, startY = 0, moved = false;
    const THRESHOLD = 8; // px of movement that turns a "tap" into a "swipe"

    this.track.addEventListener('pointerdown', (e) => {
      startX = e.clientX;
      startY = e.clientY;
      moved = false;
    });

    this.track.addEventListener('pointermove', (e) => {
      if (Math.abs(e.clientX - startX) > THRESHOLD ||
          Math.abs(e.clientY - startY) > THRESHOLD) {
        moved = true;
      }
    });

    // A cancelled gesture (e.g. the browser took over for scrolling) is a swipe.
    this.track.addEventListener('pointercancel', () => { moved = true; });

    // Native click: let keyboard (detail 0) and modifier/aux clicks pass through
    // to the real <a>; suppress plain pointer clicks because pointerup already
    // handles navigation (prevents a swipe from accidentally navigating).
    this.track.addEventListener('click', (e) => {
      const cover = e.target.closest('.hero-slider__link');
      if (!cover) return;
      if (e.detail === 0) return;                                   // keyboard Enter/Space
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return; // open in new tab, etc.
      e.preventDefault();
    });

    // Pointer tap -> navigate. This is the actual mobile fix.
    this.track.addEventListener('pointerup', (e) => {
      if (moved) return;                                            // it was a swipe
      if (e.button !== 0) return;                                   // ignore middle/right
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return; // let native new-tab win
      // Don't hijack taps on real nested controls (defensive: clickable slides
      // render their CTAs as spans, so normally there are none).
      if (e.target.closest('button, [role="button"]')) return;
      const slide = e.target.closest('[data-slide]');
      if (!slide) return;
      const link = slide.getAttribute('data-slide-link');
      if (!link) return;
      window.location.assign(link);
    });
  }

  onScroll() {
    clearTimeout(this._st);
    this._st = setTimeout(() => {
      const i = Math.round(this.track.scrollLeft / this.track.clientWidth);
      if (i !== this.index && i >= 0 && i < this.count) { this.index = i; this.update(); }
    }, 90);
  }

  go(i, userInitiated) {
    this.index = (i + this.count) % this.count;
    this.track.scrollTo({
      left: this.index * this.track.clientWidth,
      behavior: this.reduceMotion ? 'auto' : 'smooth'
    });
    this.update();
    if (userInitiated) { this.stopTimer(); this.startTimer(); } // reset the clock after a manual move
  }

  update() {
    this.dots.forEach((dot, i) => {
      const active = i === this.index;
      dot.classList.toggle('is-active', active);
      dot.setAttribute('aria-current', active ? 'true' : 'false');
    });
    if (this.live) this.live.textContent = 'Slide ' + (this.index + 1) + ' of ' + this.count;
  }

  startTimer() {
    this.stopTimer();
    if (this.autoplayEnabled && !this.userPaused) {
      this.timer = setInterval(() => this.go(this.index + 1), this.speed);
    }
  }
  stopTimer() { if (this.timer) { clearInterval(this.timer); this.timer = null; } }

  toggle() {
    this.userPaused = !this.userPaused;
    this.userPaused ? this.stopTimer() : this.startTimer();
    this.reflectToggle();
  }

  reflectToggle() {
    if (!this.toggleBtn) return;
    const playing = !this.userPaused;
    this.toggleBtn.classList.toggle('is-playing', playing);
    this.toggleBtn.setAttribute('aria-pressed', playing ? 'true' : 'false');
    this.toggleBtn.setAttribute('aria-label', playing ? 'Pause slideshow' : 'Play slideshow');
  }
}
if (!customElements.get('hero-slider')) customElements.define('hero-slider', HeroSlider);

  } catch(e) { console.error(e); }
})();
})();
